export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const calculatePhysicalBatteryVoltage = ({ battery_voltage, charging_voltage, voltage_profile }) => {
    let physical_battery_voltage = 0;

    if (voltage_profile === 'B1C0-BSP2.8b3') {
        if (battery_voltage < 2100) {
            physical_battery_voltage = (battery_voltage - 8.911504) / 181.415929;
        } else {
            physical_battery_voltage = 0.00539295 * battery_voltage - 4.831424;
        }
    } else if (voltage_profile === 'B1C0-BSP5') {
        if (charging_voltage < 10) {
            physical_battery_voltage = battery_voltage / 175.1;
        } else if (charging_voltage > 2500) {
            physical_battery_voltage = battery_voltage / 176.1;
        } else {
            physical_battery_voltage = battery_voltage / 175.1;
        }
    } else if (voltage_profile === null) {
        /**New Voltage profile */

        return +battery_voltage;
    }

    return +physical_battery_voltage.toFixed(2);
};

export const calculatePhysicalChargingVoltage = ({ charging_voltage, voltage_profile }) => {
    let physical_charging_voltage = 0;

    if (voltage_profile === 'B1C0-BSP2.8b3') {
        if (charging_voltage < 2100) {
            physical_charging_voltage = (charging_voltage - 8.911504) / 181.415929;
        } else {
            physical_charging_voltage = 0.00539295 * charging_voltage - 4.831424;
        }
    } else if (voltage_profile === 'B1C0-BSP5') {
        if (charging_voltage < 10) {
            physical_charging_voltage = 0;
        } else if (charging_voltage > 2500) {
            physical_charging_voltage = charging_voltage / 174.1;
        } else {
            physical_charging_voltage = charging_voltage / 175.1;
        }
    } else if (voltage_profile === null) {
        /**New Voltage profile */

        return +charging_voltage;
    }

    return +physical_charging_voltage.toFixed(2);
};

export const getSignalStrengthPercentage = (signalStrength) => {
    let percentage = 0;

    if (signalStrength >= 20 && signalStrength <= 35) {
        percentage = 100;
    } else if (signalStrength >= 15 && signalStrength <= 19) {
        percentage = 75;
    } else if (signalStrength >= 10 && signalStrength <= 14) {
        percentage = 50;
    } else if (signalStrength >= 2 && signalStrength <= 9) {
        percentage = 30;
    } else {
        percentage = 0;
    }

    return percentage;
};

export const getBatteryLevelPercentage = ({ battery_voltage, charging_voltage, voltage_profile }) => {
    const physicalVoltage = calculatePhysicalBatteryVoltage({ battery_voltage, charging_voltage, voltage_profile });

    let percentage = 0;

    if (physicalVoltage >= 8) {
        percentage = 100;
    }
    if (physicalVoltage >= 7.9 && physicalVoltage < 8) {
        percentage = 90;
    }
    if (physicalVoltage >= 7.7 && physicalVoltage < 7.9) {
        percentage = 60;
    }
    if (physicalVoltage >= 7.5 && physicalVoltage < 7.7) {
        percentage = 40;
    }
    if (physicalVoltage >= 7.2 && physicalVoltage < 7.5) {
        percentage = 20;
    }
    if (physicalVoltage >= 7 && physicalVoltage < 7.2) {
        percentage = 10;
    }
    if (physicalVoltage < 7) {
        percentage = 1;
    }

    return percentage;
};

export const getExternalStoragePercentage = (storage) => {
    let freeSpace = 0;
    let totalSpace = 0;

    if (storage.external) {
        freeSpace = (storage.external.size - storage.external.used) / 1024 / 1024 / 1024;
        totalSpace = storage.external.size / 1024 / 1024 / 1024;
    } else if (storage.internal) {
        freeSpace = (storage.internal.size - storage.internal.used) / 1024 / 1024 / 1024;
        totalSpace = storage.internal.size / 1024 / 1024 / 1024;
    } else {
        freeSpace = 0;
        totalSpace = 0;
    }

    const usedSpace = (totalSpace - freeSpace).toFixed(2);
    freeSpace = freeSpace.toFixed(2);
    totalSpace = totalSpace.toFixed(2);
    const percentage = Math.round((usedSpace / totalSpace) * 100);

    return { percentage, freeSpace, usedSpace, totalSpace };
};

export const formatCurrency = (number, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(number);
};
